/**
 * Fix OCR errors in MRZ name fields.
 *
 * This function replaces digits with their most commonly confused letter
 * equivalents based on known OCR confusion patterns in monospaced MRZ fonts.
 */

/** Map of digit most likely intended letter in MRZ name context. */
const OCR_DIGIT_TO_LETTER: Record<string, string> = {
  '0': 'O',
  '1': 'I',
  '2': 'Z',
  '3': 'E',
  '4': 'A',
  '5': 'S',
  '6': 'G',
  '7': 'T',
  '8': 'B',
  '9': 'G',
};

/**
 * Replaces any digit in a MRZ name string with its most probable letter.
 * Should only be applied to firstName / lastName fields, NOT to document numbers,
 * dates, or other MRZ fields where digits are valid.
 *
 * @param name - Raw name string extracted from MRZ track1
 * @returns Corrected name with digits replaced by letters
 */
export function fixOcrMrzName(name: string): string {
  if (!name) return name;
  return name.replace(/[0-9]/g, (digit) => OCR_DIGIT_TO_LETTER[digit] || digit);
}
